import {Routes} from '@/navigation/Routes';
import { Icons } from "./defaults";

export interface SideBarNavigationInterface {
  label: string;
  icon: keyof typeof Icons;
  activeIcon: keyof typeof Icons;
  route: string;
}

/**
 * side bar navigations
 */
export const superAdminSideBarNavigations: SideBarNavigationInterface[] = [
  {
    label: 'Dashboard',
    icon: 'dashboard',
    activeIcon: 'dashboard_white',
    route: Routes.DASHBOARD,
  },
  {
    label: 'Admins',
    icon: 'admins',
    activeIcon: 'admins_white',
    route: Routes.ADMIN,
  },
  {
    label: 'Access Control',
    icon: 'access',
    activeIcon: 'access_white',
    route: Routes.RBAC,
  },
  {
    label: 'Audit Log',
    icon: 'audit_log_blue',
    activeIcon: 'audit_log_white',
    route: Routes.AUDIT_LOG,
  },
  {
    label: 'Settings',
    icon: 'settings',
    activeIcon: 'settings_white',
    route: Routes.SETTINGS,
  },
] as const;

export const patientSideBarNavigations: SideBarNavigationInterface[] = [
  {
    label: 'Dashboard',
    icon: 'dashboard',
    activeIcon: 'dashboard_white',
    route: Routes.DASHBOARD,
  },
  {
    label: 'My Profile',
    icon: 'user',
    activeIcon: 'user_white',
    route: Routes.PROFILE,
  },
  {
    label: 'Specialists',
    icon: 'specialist',
    activeIcon: 'specialist_white',
    route: Routes.SPECIALISTS,
  },
  {
    label: 'Consultations',
    icon: 'consultation',
    activeIcon: 'consultation_white',
    route: Routes.CONSULTATION,
  },
  // {
  //   label: 'Activity',
  //   icon: 'activity',
  //   activeIcon: 'activity_white',
  //   route: Routes.ACTIVITY,
  // },
  {
    label: 'Settings',
    icon: 'settings',
    activeIcon: 'settings_white',
    route: Routes.SETTINGS,
  },
  {
    label: 'Help',
    icon: 'help',
    activeIcon: 'help_white',
    route: Routes.HELP,
  },
] as const;

export const adminSideBarNavigations: SideBarNavigationInterface[] = [
  {
    label: 'Dashboard',
    icon: 'dashboard',
    activeIcon: 'dashboard_white',
    route: Routes.DASHBOARD,
  },
] as const;

export const patientAdminSideBarNavigations: SideBarNavigationInterface[] = [
  {
    label: 'Dashboard',
    icon: 'dashboard',
    activeIcon: 'dashboard_white',
    route: Routes.DASHBOARD,
  },
  {
    label: 'Specialist Display',
    icon: 'specialist_display_blue',
    activeIcon: 'specialist_display_white',
    route: Routes.SPECIALIST_DISPLAY,
  },
  {
    label: 'Patient Settings',
    icon: 'display_setting_blue',
    activeIcon: 'display_setting_white',
    route: Routes.PATIENT_DISPLAY,
  },
  // {
  //   label: 'Settings',
  //   icon: 'settings',
  //   activeIcon: 'settings_white',
  //   route: Routes.SETTINGS,
  // },
] as const;

export const hospitalAdminSideBarNavigations: SideBarNavigationInterface[] = [
  {
    label: 'Dashboard',
    icon: 'dashboard',
    activeIcon: 'dashboard_white',
    route: Routes.DASHBOARD,
  },
  // {
  //   label: 'Settings',
  //   icon: 'settings',
  //   activeIcon: 'settings_white',
  //   route: Routes.SETTINGS,
  // },
  {
    label: 'Help',
    icon: 'help',
    activeIcon: 'help_white',
    route: Routes.HELP,
  },
] as const;

export const specialistSideBarNavigations: SideBarNavigationInterface[] = [
  {
    label: 'Dashboard',
    icon: 'dashboard',
    activeIcon: 'dashboard_white',
    route: Routes.DASHBOARD,
  },
  {
    label: 'My Profile',
    icon: 'user',
    activeIcon: 'user_white',
    route: Routes.PROFILE,
  },
  {
    label: 'Consultations',
    icon: 'consultation',
    activeIcon: 'consultation_white',
    route: Routes.CONSULTATION,
  },
  // {
  //   label: 'Patients',
  //   icon: 'patient2',
  //   activeIcon: 'patient2_white',
  //   route: Routes.PATIENTS,
  // },
  {
    label: 'Payments',
    icon: 'cash',
    activeIcon: 'cash_white',
    route: Routes.EARNINGS,
  },
  // {
  //   label: 'Ratings & Feedback',
  //   icon: 'feedback',
  //   activeIcon: 'feedback_white',
  //   route: Routes.RATINGS,
  // },
  {
    label: 'Settings',
    icon: 'settings',
    activeIcon: 'settings_white',
    route: Routes.SETTINGS,
  },
  {
    label: 'Help',
    icon: 'help',
    activeIcon: 'help_white',
    route: Routes.HELP,
  },
] as const;

export const hospitalPocSideBarNavigations: SideBarNavigationInterface[] = [
  {
    label: 'Dashboard',
    icon: 'dashboard',
    activeIcon: 'dashboard_white',
    route: Routes.DASHBOARD,
  },
  {
    label: 'Hospital Profile',
    icon: 'hospital',
    activeIcon: 'hospital_white',
    route: Routes.PROFILE,
  },
  {
    label: 'Consultations',
    icon: 'consultation',
    activeIcon: 'consultation_white',
    route: Routes.CONSULTATION,
  },
  {
    label: 'Help',
    icon: 'help',
    activeIcon: 'help_white',
    route: Routes.HELP,
  },
] as const;

export const supportAdminSideBarNavigations: SideBarNavigationInterface[] = [
  {
    label: 'Support Tickets',
    icon: 'support_ticket_white',
    activeIcon: 'support_ticket_white',
    route: Routes.SUPPORT_TICKETS,
  },
] as const;

export const specialistAdminSideBarNavigations: SideBarNavigationInterface[] = [
  {
    label: 'Dashboard',
    icon: 'dashboard',
    activeIcon: 'dashboard_white',
    route: Routes.DASHBOARD,
  },
  {
    label: 'Onboarding',
    icon: 'specialist',
    activeIcon: 'specialist_white',
    route: Routes.SPECIALIST_ADMIN_ONBOARDING_SPECIALIST,
  },
] as const;

export const financeAdminSideBarNavigations: SideBarNavigationInterface[] = [
  {
    label: 'Patient Payments',
    icon: 'patient',
    activeIcon: 'white_patient_payment',
    route: Routes.PATIENT_PAYMENTS,
  },
  {
    label: 'Manage Payouts',
    icon: 'specialist',
    activeIcon: 'specialist_white',
    route: Routes.SPECIALIST_PAYOUTS,
  },
] as const;